export default __webpack_public_path__ + "static/media/IMG_4658.49c529e8.JPG";